define('SageDotCom/Components/Content/CustomerSuccess/CustomerSuccessResults',["jquery",
    "underscore",
    "eventManager",
    "SageDotCom/Components/Pagination",
    "SageDotCom/DataLayer/Events/CustomerSuccess/filterEvent",
    "text!SageDotCom/Components/Templates/SpotlightResultsFilters.html",
    "text!SageDotCom/Components/Templates/SpotlightCard.html"],
    // ReSharper disable InconsistentNaming
    function ($, _, eventManager, pagination, filterEvent, _templateResultsFilters, _templateSpotlightCard) {
        function CustomerSuccessResults(scope, navigator, div, itemsPerPageDesktop, itemsPerPageMobile) {
            var $resultsFilterDiv = $(".filter-pill-container");
            var $storiesCountLabelOrig = $(".filter-props .stories-label");
            var $storiesCountLabelText = $storiesCountLabelOrig.text();
            var globalFilteredData = {};
            var marketsDisabled = false;
            var hideResultsView = true;
            var itemsPerPage = $(".customer-success-results-wrapper .customer-success-stories").hasClass("is-mobile")
                ? itemsPerPageMobile
                : itemsPerPageDesktop;

            function init() {
                $(".customer-results-view").css({ "visibility": "hidden" });
                $(".spotlight-results").hide();

                eventManager.subscribe("spotlight-filter-changed", function (filteredData) {
                    if (filteredData.length === 0) {
                        //show no results text
                        return;
                    } else {
                        globalFilteredData = filteredData;

                        if (checkFilterIsApplied(globalFilteredData)) {
                            hideResultsView = false; 
                            $(".spotlight-hero-banner").hide(); 
                            $(".spotlight-content").hide();
                            $(".spotlight-results").show();
                            $(".customer-results-view").css({ "visibility": "hidden" });
                            addSpinner($(".customer-success-results-wrapper"));

                            var $storiesCountLabel =
                                $storiesCountLabelText.replace("0", filteredData.customerSuccessData.length);
                            $storiesCountLabelOrig.html($storiesCountLabel);

                            // generate an underscore template for results page filters
                            var resultsFilterTemplate = _.template(_templateResultsFilters);
                            var html = "";
                            html += resultsFilterTemplate(filteredData);
                            $resultsFilterDiv.html(html);

                            pagination.init(scope,
                                _templateSpotlightCard,
                                navigator,
                                div,
                                filteredData.customerSuccessData,
                                itemsPerPage);

                            if ($(".filter-pill p[name=Markets]").length <= 1) {
                                $(".filter-pill p[name=Markets]").css({ "cursor": "not-allowed" });
                                $(".filter-pill p[name=Markets] span").css({ "cursor": "not-allowed", "display": "none" });
                                $(".filter-pill p[name=Markets]").removeAttr("tabindex");
                                marketsDisabled = true;
                            } else {
                                marketsDisabled = false;
                            }

                            removeSpinner($(".customer-success-results-wrapper"));
                            $(".customer-results-view").css({ "visibility": "visible" });
                            eventManager.trigger("invoke-lazy-load");
                        } else {
                            removeSpinner($(".customer-success-results-wrapper"));
                            $(".customer-results-view").css({ "visibility": "hidden" });
                            $(".spotlight-results").hide();
                            $(".spotlight-hero-banner").show(); 
                            $(".spotlight-content").show();
                        }
                    }
                });

                eventManager.subscribe("spotlight-results-reset-btn-clicked", function () {
                    hideResultsView = true;
                    $(".customer-results-view").css({ "visibility": "hidden" });
                    $(".spotlight-results").hide();
                    $(".spotlight-hero-banner").show(); 
                    $(".spotlight-content").show();

                    eventManager.trigger("spotlight-filter-reset");
                });

                eventManager.subscribe("spotlight-results-pill-clear-clicked", function (filterName, filterIndex) {
                    if (typeof globalFilteredData[filterName] !== "undefined" && globalFilteredData[filterName].length > 0) {
                        if (filterName !== "Markets" || !marketsDisabled) {
                            var facetObj = globalFilteredData[filterName][filterIndex];
                            new filterEvent(false, true, false, facetObj.name, filterName).trigger();

                            globalFilteredData[filterName].splice(filterIndex, 1);

                            addSpinner($(".customer-success-results-wrapper"));
                            $(".customer-results-view").css({ "visibility": "hidden" });
                            eventManager.trigger("spotlight-filter-result-page-change", globalFilteredData);
                        }
                    }
                });
            };

            $(".customer-results-view .filter-props").delegate(".reset-btn", "click keydown", function (e) {
                if (e.type === "click" || (e.keyCode === 13 || e.keyCode === 32)) {
                    new filterEvent(true, true).trigger();

                    eventManager.trigger("spotlight-results-reset-btn-clicked");
                }
            });
            
            $(".customer-results-view .filter-props .filter-pill-container").delegate("span.pill-clear", "click", function () {
                var filterName = $(this).parent().attr("name");
                var filterIndex = $(this).parent().attr("index");
                eventManager.trigger("spotlight-results-pill-clear-clicked", filterName, filterIndex);
            });

            $(".customer-results-view .filter-props .filter-pill-container").delegate("div.filter-pill", "keydown", function (e) {
                if (e.keyCode === 13 || e.keyCode === 32) {
                    var filterName = $(this).find("p").attr("name");
                    var filterIndex = $(this).find("p").attr("index");
                    eventManager.trigger("spotlight-results-pill-clear-clicked", filterName, filterIndex);
                }
            });
            
            //add 3 square spinner
            function addSpinner(context) {
                context.append("<div class='loader'></div>");
                var spinner = context.find(".loader");
                spinner.append("<div class='bounce bounce1'></div>");
                spinner.append("<div class='bounce bounce2'></div>");
                spinner.append("<div class='bounce bounce3'></div>");
            }

            function removeSpinner(context) {
                var spinner = context.find(".loader");
                spinner.remove();
            }

            function checkFilterIsApplied(data) {
                if (data["Industry"].length < 1 &&
                    data["Features"].length < 1 &&
                    data["Products"].length < 1 &&
                    data["Markets"].length <= 1 &&
                    hideResultsView) {

                    return false;
                } else {
                    return true;
                }
            }

            init();
        };

        return function initSpotlightResult(args) {
            return args.IsExperienceEditorEditing ? null : new CustomerSuccessResults(args.scope, args.navigator, args.div, args.itemsPerPageDesktop, args.itemsPerPageMobile);
        };
    });
